import fullLogo from '@/assets/brand-logo-full.png';
import markLogo from '@/assets/brand-logo-mark.png';
import { cn } from '@/lib/utils';

/** Single source for the MSP Vergelijker platform logo (header, footer, admin). */
export const PLATFORM_LOGO_EMAIL_URL = 'https://msp-vergelijker.nl/email/msp-vergelijker-logo.png';

interface PlatformLogoProps {
  variant?: 'full' | 'mark';
  /** Adds a light backing so the dark-navy logo stays legible on dark backgrounds. */
  onDark?: boolean;
  className?: string;
  alt?: string;
  priority?: boolean;
}

export function PlatformLogo({ variant = 'full', onDark, className, alt = 'MSP Vergelijker', priority }: PlatformLogoProps) {
  const isFull = variant === 'full';
  const img = (
    <img
      src={isFull ? fullLogo : markLogo}
      alt={alt}
      width={isFull ? 720 : 256}
      height={isFull ? 120 : 246}
      loading={priority ? 'eager' : 'lazy'}
      fetchPriority={priority ? 'high' : undefined}
      decoding="async"
      className={cn('w-auto object-contain', className)}
    />
  );
  if (!onDark) return img;
  return <span className="inline-flex items-center rounded-lg bg-card px-3 py-2">{img}</span>;
}
